var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"budget-list-wrap"},[_c('el-card',{attrs:{"header":_vm.header}},[(!_vm.isEmpty)?[_c('BudgetListItem')]:_c('el-alert',{attrs:{"type":"info","title":_vm.emptyTitle,"closable":false}})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }